module.exports = __webpack_public_path__ + "img/status_define_security_measures.b95c29b1.gif";